import {useState} from "react";

export function useHttpService() {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loading, setLoading] = useState(false);

  function request(
    method: 'get' | 'post' | 'put' | 'delete',
    uri: string,
    body: any,
    headers: any,
  ): Promise<any> {
    setLoading(true);
    return fetch(uri, {
      headers,
      body,
      method,
    }).finally(() => setLoading(false));
  }

  return {
    request,
  }
}